<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style>
  .suggestions-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    top: 36px;
}
</style>
